import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormLabel-root": {
			transform: "translate(14px, -6px) scale(0.75) ",
			backgroundColor: "#FFFF",
			transition: "none !important",
			left: -3.5,
			padding: "0 5px",
		},
		"& .MuiInputBase-input": {
			color: "black",
			paddingRight: 45,
		},
	},
}));

type Props = {
	searchData: Function;
};
// MuiGrid-item
export const SearchFilter = ({ searchData }: Props) => {
	const classes = useStyles();
	//routes
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";

	const onKeyDown = (e: any) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			searchData();
		}
	};

	const handleFilter = (e: any) => {
		searchParams.set("search", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div style={{ position: "relative" }}>
			<TextField
				className={classes.root}
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search"
				variant="outlined"
				margin="dense"
				value={search}
				onChange={handleFilter}
				onKeyDown={onKeyDown}
				fullWidth
				autoComplete="off"
			/>
			<>
				<i
					className="fa fa-search"
					style={{
						position: "absolute",
						right: 17,
						top: 20,
						cursor: "pointer",
					}}
				></i>
			</>
		</div>
	);
};
